import { Component, inject } from '@angular/core';
import { EonUiButton } from '@eon-ui/eon-ui-components-angular';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { GameService } from '../../../service/game.service';
import { TranslatePipe } from '@ngx-translate/core';
import { GameThemeService } from '../../../service/game-theme.service';

@Component({
  selector: 'gandalf-game-over-dialog',
  imports: [EonUiButton, MatDialogActions, MatDialogContent, TranslatePipe],
  templateUrl: './game-over-dialog.component.html',
  styleUrl: './game-over-dialog.component.scss',
})
export class GameOverDialogComponent {
  protected readonly gameService = inject(GameService);
  private readonly gameThemeService = inject(GameThemeService);
  protected readonly eonUiScheme = this.gameThemeService.getEonUiScheme();
  private dialogRef = inject(MatDialogRef<GameOverDialogComponent>);

  public restartGame(): void {
    this.dialogRef.close();
    this.gameService.restartGame();
  }
}
